import { PropsWithChildren } from "react";

import { ContentContainer, ThemedGradient } from "@/premium/themedComponents";

import styles from "./PageLayout.module.scss";

export const PageLayout = (props: PropsWithChildren & {showGradient?: boolean}) => {
  const { children, showGradient = true } = props;

  return (
    <ContentContainer>
      {showGradient && <ThemedGradient />}
      <div className={styles["page-wrapper"]}>{children}</div>
    </ContentContainer>
  );
};
